
<template>
  <div id="tranksaksi-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
    <vs-sidebar class="items-no-padding" parent="#tranksaksi-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isSidebarFilterActive">

        <component :is="scrollbarTag" class="tranksaksi-scroll-area" :settings="settings" :key="$vs.rtl">
            <pembelian-filters @closeSidebar="toggleFilterSidebar" @openSupplierAdd="openSupplierAddSidebar"
            @openSupplierEdit="openSupplierEditSidebar"
            @openKategoriAdd="kategoriOpenAddSidebar" 
            :pembelianFilter="pembelianFilter"
            :Search="search"
            :maxRange="pembelianMaxRange"
            :dateMulai="mulai"
            :dateSampai="sampai"></pembelian-filters>
        </component>
    </vs-sidebar>

    <div :class="{'sidebar-spacer': clickNotClose}"  id="pembelian-load" class="no-scroll-content border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light no-scroll-content vs-con-loading__container">

      <div class="flex d-theme-dark-bg items-center border border-l-0 border-r-0 border-t-0 border-solid d-theme-border-grey-light">

          <!-- TOGGLE SIDEBAR BUTTON -->
          <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" @click.stop="toggleFilterSidebar(true)" />

          <!-- SEARCH BAR -->
          <vs-input icon-no-border size="large" icon-pack="feather" icon="icon-search" placeholder="Search..." v-model="search" v-on:keyup.enter="filterData()" class="vs-input-no-border vs-input-no-shdow-focus w-full" v-if="pembelianFilter != 'trash'"/>
          
      </div>

      <div class="flex items-center flex-wrap justify-between py-2 md:px-8 px-4">
          <div class="flex" v-if="pembelianFilter != 'trash'">
            <flat-pickr format="yyyy-MM-dd" :config="configFromdateTimePicker" v-model="mulai" placeholder="Mulai" @on-change="onFromChange" class="mr-4" style="width:100px;height: 32px;"/>
            <flat-pickr format="yyyy-MM-dd" :config="configTodateTimePicker" v-model="sampai" placeholder="Sampai" @on-change="onToChange" class="mr-2" style="width:100px;height: 32px;"/>
            <feather-icon @click="filterData" icon="ArrowRightIcon" class="cursor-pointer" svg-classes="h-7 w-7"></feather-icon>
          </div>
          <div class="flex items-center">
            <div class="dropdown-button-container">
              <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
                <feather-icon icon="CodeIcon" class="cursor-pointer" svg-classes="h-7 w-7"></feather-icon>
                <vs-dropdown-menu>
                  <vs-dropdown-item v-for="p in pembelianPage" :key="p" @click.stop="nextData(p)" :disabled="p === pembelianCurrentPage">
                    {{ p }}
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>

            <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer" v-if="pembelianFilter != 'trash'">
              <feather-icon icon="PlusIcon" class="cursor-pointer ml-5" svg-classes="h-7 w-7"></feather-icon>
              <vs-dropdown-menu>

                <vs-dropdown-item class="p-2" v-for="kategori in pembelianKategoris" :key="kategori.slug" @click="addUpdateSidebar(kategori.id)">
                  <span class="flex items-center text-lg font-medium w-32">
                    <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-2" />
                    <span class="text-sm">{{ kategori.name }}</span>
                  </span>
                </vs-dropdown-item>

              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
      </div>

      <!-- KAS LIST -->
      <component :is="scrollbarTag" id="pembelian-load" class="tranksaksi-content-scroll-area" :settings="settings" ref="tranksaksiListPS" :key="$vs.rtl">

          <transition-group name="list-enter-up" tag="ul" appear>
            <li
              class="cursor-pointer"
              v-for="(tranksaksi, index) in tranksaksiList"
              :key="String(pembelianFilter) + String(tranksaksi.id)"
              :style="[{transitionDelay: (index * 0.1) + 's'}]"
              @click="viewUpdateSidebar(tranksaksi)">

              <pembelian-item 
                :data="tranksaksi" 
              />
            </li>
          </transition-group>
      </component>
      <!-- /KAS LIST -->
    </div>

    <pembelian-kategori-add :isKategoriAddActive="isKategoriAddActive" @kategoriCloseAdd="kategoriCloseAddSidebar"></pembelian-kategori-add>
    <pembelian-supplier-add :isSupplierAddActive="isSupplierAddActive" @closeSupplierAdd="closeSupplierAddSidebar" :supplierData="dataSupplier"></pembelian-supplier-add>
    <pembelian-update 
      :isUpdateActive="isUpdateActive"
      @closeUpdate="closeUpdateSidebar"
      :data="dataTranksaksi" 
      :tags="pembelianTags"
      :kategori="kategoriUpdate">
    </pembelian-update>
  </div>
</template>

<script>
import PembelianItem from './PembelianItem.vue'
import PembelianFilters from './PembelianFilters.vue'
import PembelianKategoriAdd from './PembelianKategoriAdd.vue'
import PembelianSupplierAdd from './PembelianSupplierAdd.vue'
import PembelianUpdate from './PembelianUpdate.vue'

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import modulePembelian from '@/stores/tranksaksi/moduleTranksaksi.js'
import moduleSupplier from '@/stores/term/kontak.js'

export default {
  components: {
    PembelianItem,
    PembelianFilters,
    PembelianKategoriAdd,
    PembelianSupplierAdd,
    PembelianUpdate,
    VuePerfectScrollbar,
    flatPickr
  },
  data () {
    return {
      dataTranksaksi       : {},
      isKategoriAddActive : false,
      isSupplierAddActive   : false,
      dataSupplier            : {},
      currFilter           : '',
      clickNotClose        : true,
      displayPrompt        : false,
      isSidebarFilterActive: true,

      isUpdateActive       : false,
      kategoriUpdate       : 0,

      settings : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.30
      },

      configFromdateTimePicker: {
        minDate: null,
        maxDate: null
      },
      configTodateTimePicker: {
        minDate: null
      },
      changeMulai: false,

      // Param
      search: '',
      mulai: null,
      sampai: null,
    }
  },
  watch: {
    isSupplierAddActive (value) {
      if (!value) this.showThread = false
    },
    isUpdateActive (value) {
      if (!value) this.showThread = false
    },
    pembelianFilter () {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#pembelian-load',
        type: 'sound',
        scale: 0.5
      })
      const scroll_el = this.$refs.tranksaksiListPS.$el || this.$refs.tranksaksiListPS
      scroll_el.scrollTop = 0
      this.$store.commit('pembelian/UPDATE_KAS_FILTER', this.$route.params.filter)
      const obj = {
        sub_type: 'pembelian',
        filter_type: this.$route.params.filter_type,
        filter: this.$route.params.filter,
        search: this.search,
        range: this.$store.state.pembelian.state_range,
        dateMulai: this.mulai,
        dateSampai: this.sampai
      }
      this.$store.commit('pembelian/SET_NULL_TASKS')
      this.$store.dispatch('pembelian/fetchTranksaksi', obj)
      if (this.$store.state.pembelian.tranksaksis.length > 0 || this.$store.state.pembelian.tranksaksis.length === 0) {
        setTimeout(() => {
          this.$vs.loading.close('#pembelian-load > .con-vs-loading')
        }, 2000)
      }
      this.toggleFilterSidebar()
    },
    windowWidth () {
      this.setSidebarWidth()
    }
  },
  computed: {
    pembelianFilter ()   { return this.$route.params.filter },
    tranksaksiList ()     { return this.$store.state.pembelian.tranksaksis      },
    pembelianTags () {
      return this.$store.state.pembelian.tranksaksiTags
    },
    pembelianKategoris () {
      return this.$store.state.pembelian.tranksaksiKategoris
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    windowWidth ()  { return this.$store.state.windowWidth },
    pembelianTotal () {
      return this.$store.state.pembelian.total
    },
    pembelianTotalSatu () {
      return this.$store.state.pembelian.total + 1
    },
    pembelianLast () {
      return this.$store.state.pembelian.last
    },
    pembelianPerPage () {
      return this.$store.state.pembelian.per_page
    },
    pembelianCurrentPage () {
      return this.$store.state.pembelian.current_page
    },
    pembelianPage () {
      const page = []
      const number = this.$store.state.pembelian.total / this.$store.state.pembelian.per_page
      var i
      for (i=0; i < number; i++) {
        page.push(i+1)
      }
      return page
    },
    pembelianTotalPage () {
      let number = this.$store.state.pembelian.total / this.$store.state.pembelian.per_page
      if (number < 1) {
        number = 1
      }
      return number.toFixed(0)
    },
    pembelianMaxRange () {
      return this.$store.state.pembelian.max_range
    }
  },
  created () {
    this.$vs.loading()
    this.$store.registerModule('pembelian', modulePembelian)
    this.$store.registerModule('supplier', moduleSupplier)
    this.setSidebarWidth()

    const obj = {
      sub_type: 'pembelian',
      filter_type: this.$route.params.filter_type,
      filter: this.$route.params.filter
    }
    // Fetch
    this.$store.dispatch('pembelian/fetchTranksaksi', obj)
    this.$store.dispatch('pembelian/fetchTag', 'pembelian')
    this.$store.dispatch('supplier/fetchKontakGroupTaxonomySlug', 'supplier')
    this.$store.commit('pembelian/UPDATE_KAS_FILTER', this.$route.params.filter)
    if (this.$store.state.pembelian.tranksaksis.length > 0|| this.$store.state.pembelian.tranksaksis.length === 0) {
      setTimeout(() => {
        this.$vs.loading.close()
      }, 2000)
    }
  },
  beforeUpdate () {
    this.currFilter = this.$route.params.filter
  },
  beforeDestroy () {
    this.$store.unregisterModule('pembelian')
    this.$store.unregisterModule('supplier')
  },
  mounted () { 
  },
  methods: {
    onFromChange(selectedDates, dateStr) {
      this.changeMulai = true
      this.$set(this.configTodateTimePicker, 'minDate', dateStr)
    },
    onToChange(selectedDates, dateStr) {
      if (this.changeMulai != false) {
        this.$set(this.configFromdateTimePicker, 'maxDate', dateStr)
      } else {
        this.$vs.notify({
          title: 'Error',
          text: 'Pilih tanggal mulai',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
      
    },
    setSidebarWidth () {
      if (this.windowWidth < 992) {
        this.isSidebarFilterActive = this.clickNotClose = false
      } else {
        this.isSidebarFilterActive = this.clickNotClose = true
      }
    },
    toggleFilterSidebar (value = false) {
      if (!value && this.clickNotClose) return
      this.isSidebarFilterActive = value
    },
    kategoriOpenAddSidebar() {
      this.isKategoriAddActive = true
    },
    kategoriCloseAddSidebar () {
      this.isKategoriAddActive = false
    },
    openSupplierAddSidebar() {
      this.isSupplierAddActive = true
      this.dataSupplier = {}
    },
    openSupplierEditSidebar(data) {
      this.isSupplierAddActive = true
      this.dataSupplier = data
    },
    closeSupplierAddSidebar () {
      this.isSupplierAddActive = false
    },
    addUpdateSidebar(kategori) {
      this.dataTranksaksi = {}
      this.isUpdateActive = true
      this.kategoriUpdate = kategori
    },
    viewUpdateSidebar(data) {
      this.dataTranksaksi = data
      this.isUpdateActive = true
      this.kategoriUpdate = data.kategori.id
    },
    closeUpdateSidebar () {
      this.isUpdateActive = false
      this.kategoriUpdate = 0
    },
    nextData (page) {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#pembelian-load',
        type: 'sound',
        scale: 0.5
      })
      const scroll_el = this.$refs.tranksaksiListPS.$el || this.$refs.tranksaksiListPS
      scroll_el.scrollTop = 0

      this.$store.commit('pembelian/UPDATE_KAS_FILTER', this.$route.params.filter)
      const obj = {
        sub_type: 'pembelian',
        filter_type: this.$route.params.filter_type,
        filter: this.$route.params.filter,
        search: this.search,
        range: this.$store.state.pembelian.state_range,
        dateMulai: this.mulai,
        dateSampai: this.sampai,
        page: page
      }
      this.$store.commit('pembelian/SET_NULL_TASKS')
      this.$store.dispatch('pembelian/fetchTranksaksi', obj)
      if (this.$store.state.pembelian.tranksaksis.length > 0 || this.$store.state.pembelian.tranksaksis.length === 0) {
        setTimeout(() => {
          this.$vs.loading.close('#pembelian-load > .con-vs-loading')
        }, 2000)
      }
    },
    filterData () {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#pembelian-load',
        type: 'sound',
        scale: 0.5
      })
      const scroll_el = this.$refs.tranksaksiListPS.$el || this.$refs.tranksaksiListPS
      scroll_el.scrollTop = 0

      this.$store.commit('pembelian/UPDATE_KAS_FILTER', this.$route.params.filter)
      const obj = {
        sub_type: 'pembelian',
        filter_type: this.$route.params.filter_type,
        filter: this.$route.params.filter,
        search: this.search,
        range: this.$store.state.pembelian.state_range,
        dateMulai: this.mulai,
        dateSampai: this.sampai
      }

      this.$store.commit('pembelian/SET_NULL_TASKS')
      this.$store.dispatch('pembelian/fetchTranksaksi', obj)
      if (this.$store.state.pembelian.tranksaksis.length > 0 || this.$store.state.pembelian.tranksaksis.length === 0) {
        setTimeout(() => {
          this.$vs.loading.close('#pembelian-load > .con-vs-loading')
        }, 2000)
      }
    }
  }
}

</script>


<style lang="scss">
  @import "@/assets/scss/vuexy/apps/tranksaksi.scss";
  .dropdown-button-container {
    display: flex;
    align-items: center;

    .btnx {
      border-radius: 5px 0px 0px 5px;
    }

    .btn-drop {
      border-radius: 0px 5px 5px 0px;
      border-left: 1px solid rgba(255, 255, 255, .2);
    }
  }
  .total-slider {
    min-width: unset;
  }
</style>
